import useSessionCopyOrMove from '../data/exercise-sessions/useSessionCopyOrMove';
import useAddFavoriteMeal from '../data/meals/useAddFavoriteMeal';
import useMealCopyOrMove from '../data/meals/useMealCopyOrMove';

const useDatePickerAction = ({ action, isExercise, currentDay, selectedEntryId }) => {
    const sessionHook = useSessionCopyOrMove(action, currentDay);
    const addFavoriteHook = useAddFavoriteMeal(currentDay);
    const mealHook = useMealCopyOrMove(action, currentDay, selectedEntryId);

    // EXERCISE
    if (isExercise) {
        return sessionHook;
    }

    // ADD FAVORITE MEAL
    if (action === 'add') {
        if (!selectedEntryId) throw new Error('useDatePickerAction: selectedEntryId is required for add');

        return {
            triggerAction: ({ date, mealType, name }) =>
                addFavoriteHook.addFavoriteMeal({
                    favoriteId: selectedEntryId,
                    date,
                    mealType,
                    name
                }),
            isProcessing: addFavoriteHook.isAdding,
            isError: addFavoriteHook.isError,
            error: addFavoriteHook.error,
            reset: addFavoriteHook.reset
        };
    }

    // COPY / MOVE MEAL
    return mealHook;
};

export default useDatePickerAction;
